const _isAttrsMapEqual = (
  // 在已有资源内查找是否已存在（除了name不一致，其他都一样）
  attrsMap1: Record<string, string>,
  attrsMap2: Record<string, string>,
  ignoreAttrs?: string[]
) => {
  const _ignoreAttrs = [
    'name',
    '_id',
    '_shapeId',
    '_name',
    '_asWidget',
    '_label',
    '_as',
    ...(ignoreAttrs ?? [])
  ];
  const attrsMap1Keys = Object.keys(attrsMap1).filter(
    (key) => _ignoreAttrs.includes(key) == false
  );
  const attrsMap2Keys = Object.keys(attrsMap2).filter(
    (key) => _ignoreAttrs.includes(key) == false
  );

  return (
    attrsMap1Keys.length == attrsMap2Keys.length &&
    attrsMap1Keys.every((key) => {
      const equal = attrsMap1[key] == attrsMap2[key];
      return equal;
    })
  );
};

const _isChildrenEqual = (
  children1: Ast[],
  children2: Ast[],
  ignoreAttrs?: string[],
  // 是否忽略children的顺序
  ignoreChildSort?: boolean
) => {
  if (children1.length !== children2.length) return false;

  // 如果忽略children的顺序
  if (ignoreChildSort) {
    let res = true;
    const _children2 = [...children2];
    for (let i = 0; i < children1.length; i++) {
      if (!res) break;

      const child = children1[i];
      const index = _children2.findIndex((item) =>
        isAstEqual(child, item, ignoreAttrs, ignoreChildSort)
      );
      if (index > -1) {
        _children2.splice(index, 1);
      } else {
        // 不一致，直接返回false
        res = false;
        break;
      }
      return res;
    }
    return res;
  } else {
    let res = true;
    for (let i = 0; i < children1.length; i++) {
      const child = children1[i];
      if (res == false) continue;
      res = isAstEqual(child, children2[i], ignoreAttrs);
    }
    return res;
  }
};

/**
 * 返回两个ast是否一致，即tag和attrsMap是否一致，如果有children需要在按照此规则比对children
 * @param ast1
 * @param ast2
 * @param ignoreAttrs 比对时（包括children）需要忽略的属性名称
 * @returns
 */
export const isAstEqual = (
  ast1: Ast,
  ast2: Ast,
  ignoreAttrs?: string[],
  ignoreChildSort?: boolean
): boolean => {
  const tagEqual = ast1.tag == ast2.tag;
  const attrsMapEqual = _isAttrsMapEqual(
    ast1.attrsMap,
    ast2.attrsMap,
    ignoreAttrs
  );
  const childrenEqual = _isChildrenEqual(
    ast1.children,
    ast2.children,
    ignoreAttrs,
    ignoreChildSort
  );

  return tagEqual && attrsMapEqual && childrenEqual;
};
